/**
 * Service Layer Auth Context
 * 
 * React context and hook for Service Layer authentication.
 */

import { createContext, useContext } from 'react';
import { ServiceLayerAuthContextValue } from './authTypes';

const ServiceLayerAuthContext = createContext<ServiceLayerAuthContextValue | null>(null);

export function useServiceLayerAuth(): ServiceLayerAuthContextValue {
  const ctx = useContext(ServiceLayerAuthContext);
  if (!ctx) throw new Error('useServiceLayerAuth must be used within ServiceLayerAuthProvider');
  return ctx;
}

export { ServiceLayerAuthContext };

